/**
 * Hook pour la gestion de la connexion Socket.io
 */

import { useEffect } from 'react';
import { socketService } from '../services/socketService';
import { useGameStore } from '../store/gameStore';

export function useSocket() {
  const connected = useGameStore((state) => state.connected);

  useEffect(() => {
    socketService.connect();

    return () => {
      // Ne pas déconnecter à chaque unmount pour garder la connexion active
    };
  }, []);

  return { connected };
}
